import getQuoteByKey from 'core/services/getQuoteByKey'

async function getAndParseQuote(quoteKey: string) {
  const quoteResult = await getQuoteByKey(quoteKey)

  if (quoteResult.error) {
    return [quoteResult.error, undefined]
  }

  if (!quoteResult.data) {
    return [new Error('No data found'), undefined]
  }

  return [undefined, [quoteResult.data, undefined]] // It is only necessary to key a placeholder for the rec engine data
}

export default getAndParseQuote
